import DEFAULT_TOOLBOX from '../../blocks/toolbox.json'
import theme from './theme'

const STATIC_TOOLBOX = {
  ...DEFAULT_TOOLBOX,
  contents: DEFAULT_TOOLBOX.contents.filter((category) => !category.custom),
}

const config = {
  // iPad/モバイルで window.prompt に切り替わると Safari のダイアログ抑制で
  // 値変更が不能になるため、常にインラインエディタを使う。
  modalInputs: false,
  move: {
    scrollbars: true,
    drag: true,
    wheel: true,
  },
  renderer: 'zelos',
  theme,
  // Callbacks for custom dynamic categories are registered after the workspace is created,
  // so use a toolbox with only static categories until after initialization.
  toolbox: STATIC_TOOLBOX,
  trashcan: false,
  zoom: {
    controls: true,
    maxScale: 3,
    minScale: 0.3,
    pinch: true,
    scaleSpeed: 1.2,
    startScale: 5 / 6,
    wheel: true,
  },
}

export default config
